<template>
    <div>
        <div v-for="(value) in allDataArray" :key="value">
            <!--            {{allData[value].data}}-->
            <div v-if="$comUtils.isNotEmpty(allData) && $comUtils.isNotEmpty(fieldOptions)">
                <label >{{allConfig[value].title}}</label>
                <data-area-group :field-options="fieldOptions"
                                 :group-key="value"
                                 :sjj-id="sjjId"
                                 :width="width"
                                 :ref="refPrefix + value"
                                 @validateResultChange="groupValidateResultChange" :data.sync="allData[value].data"
                                 :rules="computedRules[value]" :default-item-data="allConfig[value].defaultItemData"
                                 :menu-config="allConfig[value].menuConfig">
                </data-area-group>
            </div>
        </div>
    </div>
</template>

<script>
    import DataAreaGroup from "./DataAreaGroup";
    import dataAreaRules from "@/utils/DataAreaRules"

    export default {
        name: "DataArea",
        components: {DataAreaGroup},
        props: {
            // 数据集id
            sjjId: {
                type: String,
                required: true
            },
            // 可选的字段
            fieldOptions: {
                type: Array,
                required: true
            },
            // 回传数据 .sync
            data: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            // 图表类型
            chartType: {
                type: String,
                required: true
            },
            // 回传校验结果 .sync
            dataValidateResult: {
                type: Array,
            },
            // 组件宽度，单位px
            width: {
                type: Number,
                default: 250
            }
        },
        data: function () {
            return {
                // 数据区数据
                allData: {},
                // 数据区的整体规则
                rules: {},
                // 不同组的配置
                allConfig: {
                    yAxis: {
                        // 组标题
                        title: '值轴/度量',
                        // 菜单配置
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: [], // 不显示的菜单项 数组或'ALL'
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter' && menuItem.key !== 'format') {
                                    let enable;
                                    if (dataAreaItemData.fieldData.fieldTypeTrans === '1') {
                                        enable = ['0', '1', '2', 'noFormat', 'custom'];
                                    } else {
                                        enable = ['date1','date2','date3','date4', 'noFormat', 'custom'];
                                    }
                                    return enable.indexOf(menuItem.key) >= 0 ? 1 : -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        // 默认数据
                        defaultItemData: function (field) {
                            if (field.isComputed === '1') {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: '',
                                    fieldData: {},
                                }
                            } else {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: '',
                                    fieldData: {},
                                }
                            }

                        }
                    },
                    yAxisBLA: {
                        // 组标题
                        title: '值轴/度量',
                        // 菜单配置
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: [], // 不显示的菜单项 数组或'ALL'
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter') {
                                    let enable;
                                    if (dataAreaItemData.fieldData.fieldTypeTrans === '1') {
                                        enable = ['0', '1', '2', 'noFormat', 'custom'];
                                    } else {
                                        enable = ['date1','date2','date3','date4', 'noFormat', 'custom'];
                                    }
                                    return enable.indexOf(menuItem.key) >= 0 ? 1 : -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        // 默认数据
                        defaultItemData: function (field) {
                            if (field.isComputed === '1') {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: 'bar',
                                    fieldData: {},
                                }
                            } else {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: 'bar',
                                    fieldData: {},
                                }
                            }

                        }
                    },
                    xAxis: {
                        title: '类别轴/维度',
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: ['moreExpression', 'noExpression', 'count', 'avg', 'sum', 'splitLine-1'], // 不显示的菜单项 数组或'ALL',
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter') {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        defaultItemData:function (field) {
                            return {
                                expression: {},
                                formatter: {},
                                fieldNameOrigin: '',
                                fieldNameRename: '',
                                order: {displayText: "无序", value: "no"},
                                BLA: '',
                                fieldData: {},
                            }
                        }
                    },
                    legend: {
                        title: '颜色图例/维度',
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: ['moreExpression', 'noExpression', 'count', 'avg', 'sum', 'splitLine-1'], // 不显示的菜单项 数组或'ALL',
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter') {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        defaultItemData: function (field) {
                            return {
                                expression: {},
                                formatter: {},
                                fieldNameOrigin: '',
                                fieldNameRename: '',
                                order: {displayText: "无序", value: "no"},
                                BLA: '',
                                fieldData: {},
                            }
                        }
                    },
                    filter: {
                        title: '过滤器',
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: [], // 不显示的菜单项 数组或'ALL'
                        },
                        defaultItemData: function () {

                        }
                    },
                    //饼图
                    angle: {
                        // 组标题
                        title: '扇区角度/度量',
                        // 菜单配置
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: [], // 不显示的菜单项 数组或'ALL'
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter' && menuItem.key !== 'format') {
                                    let enable;
                                    if (dataAreaItemData.fieldData.fieldTypeTrans === '1') {
                                        enable = ['0', '1', '2', 'noFormat', 'custom'];
                                    } else {
                                        enable = ['date1','date2','date3','date4', 'noFormat', 'custom'];
                                    }
                                    return enable.indexOf(menuItem.key) >= 0 ? 1 : -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        // 默认数据
                        defaultItemData: function (field) {
                            if (field.isComputed === '1') {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: '',
                                    fieldData: {},
                                }
                            } else {
                                return {
                                    expression: {displayText: "求和", value: "SUM"},
                                    formatter: {displayText: "无格式", value: "no"},
                                    fieldNameOrigin: '',
                                    fieldNameRename: '',
                                    order: {displayText: "无序", value: "no"},
                                    BLA: '',
                                    fieldData: {},
                                }
                            }

                        }
                    },
                    textLabel: {
                        title: '文本标签/维度',
                        menuConfig: {
                            disabled: [], // 禁用的菜单项 数组或'ALL'
                            noVisible: ['moreExpression', 'noExpression', 'count', 'avg', 'sum', 'splitLine-1'], // 不显示的菜单项 数组或'ALL',
                            checker: function (menuItem, dataAreaItemData) {
                                if (menuItem.group === 'formatter') {
                                    return -1;
                                } else {
                                    return 1;
                                }
                            },
                        },
                        defaultItemData:function (field) {
                            return {
                                expression: {},
                                formatter: {},
                                fieldNameOrigin: '',
                                fieldNameRename: '',
                                order: {displayText: "无序", value: "no"},
                                BLA: '',
                                fieldData: {},
                            }
                        }
                    },                 
                },
                // ref 前缀
                refPrefix: 'DATA_AREA_GROUP_',
                // 各个组的验证结果
                validateResults: {},
                //
                usageGroup: [],
            }
        },
        methods: {
            // 获取默认数据
            getDefaultData: function () {
                // console.log(dataAreaRules)
                let groups = this.allDataArray;
                let res = {};
                for (let j = 0; j < groups.length; j++) {
                    res[groups[j]] = {
                        key: groups[j],
                        data: [],
                    };
                }
                return res;
            },
            // 获取图表对应规则
            getRules: function () {
                for (let i = 0; i < dataAreaRules.length; i++) {
                    let item = dataAreaRules[i];
                    if (item.charts.indexOf(this.chartType) >= 0) {
                        this.rules = item.rules;
                        break;
                    }
                }
            },
            // 获取数据校验结果
            getDataValidateResult: function () {
                let refs = this.validateResults;
                let res = [];
                // console.log(refs);
                for (let key in refs) {
                    let result = refs[key];
                    result.key = key;
                    if (!result.result) {
                        res.push(result);
                    }
                }
                return res;
            },
            // 组校验结果改变
            groupValidateResultChange: function (res, key) {
                this.validateResults[key] = res;
            }
        },
        computed: {
            // 每个组的字段选择信息
            allGroupInfo: function () {
                let res = {};
                let data = this.allData;
                let keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    let datum = data[keys[i]];
                    let usedFields = [];
                    res[keys[i]] = {};
                    for (let j = 0; j < datum.data.length; j++) {
                        let fieldName = datum.data[j].fieldNameOrigin;
                        usedFields.push(fieldName);
                    }
                    res[keys[i]].usedFields = usedFields;
                }
                return res;
            },
            // 规则分组并进行关联处理
            computedRules: function () {
                let rules = this.rules;
                let res = {};
                let keys = Object.keys(rules);
                for (let i = 0; i < keys.length; i++) {
                    let rule = rules[keys[i]];
                    // 一般规则
                    res[keys[i]] = jQuery.extend(true, {}, rule.normal);
                    // 处理关联规则
                    if (this.$comUtils.isNotEmpty(rule.related)) {
                        // 当前组的已选字段 对应 trigger 和 relateRules 中的 'data'
                        let data = this.allGroupInfo[keys[i]].usedFields;
                        for (let j = 0; j < rule.related.length; j++) {
                            let item = rule.related[j];
                            // 关联组的已选字段 对应 trigger 和 relateRules 中的 'dataRe'
                            let dataRe = this.allGroupInfo[item.relateTarget].usedFields;
                            // 检查是否触发
                            let use = eval(item.trigger);
                            // 触发后进行规则变换
                            if (use === true) {
                                if (item.mode.toUpperCase() === 'REPLACE') {
                                    for (let k in item.relateRules) {
                                        res[keys[i]][k] = eval(item.relateRules[k]);
                                    }
                                } else {
                                    for (let k2 in item.relateRules) {
                                        // 'range' 和 'fieldRepeat' 规则属于只能替换的类型
                                        if (k2 === 'range' || k2 === 'fieldRepeat') {
                                            res[keys[i]][k2] = eval(item.relateRules[k2]);
                                        } else {
                                            // 进行规则合并
                                            let mergeVal = eval(item.relateRules[k2].value);
                                            if (this.$comUtils.isEmpty(res[keys[i]][k2])) {
                                                res[keys[i]][k2] = {
                                                    value: [],
                                                    message: '',
                                                };
                                            }
                                            res[keys[i]][k2].value.push(...mergeVal);
                                            res[keys[i]][k2].message = item.relateRules[k2].message;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                // console.log('规则更新', res);
                return res;
            },
            // 指定类型数据区启用的组
            allDataArray: function () {
                for (let i = 0; i < dataAreaRules.length; i++) {
                    let item = dataAreaRules[i];
                    if (item.charts.indexOf(this.chartType) >= 0) {
                        return item.usedGroups;
                    }
                }
                return [];
            }
        },
        watch: {
            allData: {
                handler: function (nv, ov) {
                    this.$emit('update:data', nv);
                    this.$nextTick(() => {
                        let dataValidateResult = this.getDataValidateResult();
                        this.$emit('update:dataValidateResult', dataValidateResult);
                    });
                    // console.log('数据更新', nv);
                },
                deep: true
            },
            data: {
                handler: function (nv, ov) {
                    if (this.$comUtils.isEmpty(nv)) {
                        this.allData = this.getDefaultData();
                    } else {
                        this.allData = nv;
                    }
                },
                deep: true,
            },
            chartType: function (nv, ov) {
                // console.log(dataAreaRules)
                this.getRules();
            }
        },
        mounted() {
            this.$root.$off('clickBlank');
            this.$root.$off('closeOther');
            // this.allData = this.data;
            // if (this.$comUtils.isEmpty(this.allData)) {
            //     this.allData = this.getDefaultData();
            // }
            this.getRules();
            this.$nextTick(() => {
                this.getDataValidateResult();
            })
            // let a = eval('true');
            // console.log(a ? 'T' : 'F');
        }
    }
</script>

<style scoped>
</style>
